import { Capacitor } from '@capacitor/core';

/**
 * Which build this bundle is: "web" (browser portal) or "app" (the Capacitor
 * Android/iOS build). Set with REACT_APP_BUILD_FOR in .env — `npm run
 * build:app` forces "app". Sent to the API on every request as `build_for`.
 */
export const BUILD_FOR = process.env.REACT_APP_BUILD_FOR === 'app' ? 'app' : 'web';

export const isAppBuild = BUILD_FOR === 'app';

/** True only when actually running inside the native Android/iOS shell. */
export const isNativePlatform = () => Capacitor.isNativePlatform();
